import React, { Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { MotionModal } from '../../../components/motion-modal/motion-modal';
import { useView } from '../../../components/motion-modal/view/context';
import { useDeleteRecordings } from '../../../queries/ats/recordings/mutations';
import { SeriesRecording } from '../../../queries/ats/recordings/types/recording';
import { FocusedAsset } from '../use-focused-asset';
import css from './delete-recording-modal.module.scss';

interface DeleteSeasonsRecordingScreenProps {
  focusedAsset: FocusedAsset;
  seasonNumbers: number[];
}

export function DeleteSeasonsRecordingScreen({ seasonNumbers }: DeleteSeasonsRecordingScreenProps) {
  const { t } = useTranslation();

  return (
    <Fragment>
      {seasonNumbers.map((season) => (
        <MotionModal.ViewButton key={season} id={`season-${season}`}>
          Season {season}
        </MotionModal.ViewButton>
      ))}

      <MotionModal.ViewBackButton className={css.cancel}>{t('cancel')}</MotionModal.ViewBackButton>
    </Fragment>
  );
}

interface ConfirmDeleteSeasonScreenProps {
  focusedAsset: FocusedAsset;
  recording: SeriesRecording;
  season: number;
}

export function ConfirmDeleteSeasonScreen({ focusedAsset, recording, season }: ConfirmDeleteSeasonScreenProps) {
  const { t } = useTranslation();
  const { mutate, isLoading } = useDeleteRecordings();
  const { setView } = useView();

  const name = focusedAsset.type === 'episode' ? focusedAsset.series.titleName : focusedAsset.titleName;

  const episodes = recording.episodes.filter((rec) => rec.season.sequenceNumber === season);

  return (
    <Fragment>
      <p className={css.text}>
        <Trans i18nKey="delete-seasons-description" ns="recordings" values={{ name, season }} />
      </p>

      <div className={css.actions}>
        <MotionModal.Button
          className={css.confirm}
          onClick={() =>
            mutate(
              episodes.map((rec) => rec.id),
              { onSuccess: () => setView('seasons') },
            )
          }
          isLoading={isLoading}
          isDisabled={isLoading}
        >
          {t('confirm')}
        </MotionModal.Button>
        <MotionModal.ViewButton id="seasons" className={css.cancel} isDisabled={isLoading}>
          {t('cancel')}
        </MotionModal.ViewButton>
      </div>
    </Fragment>
  );
}
